export default __webpack_public_path__ + "static/media/foto10.bead95f7.jpg";